var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseCircleSolid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.27995 2 2 8.27995 2 16C2 23.7201 8.27995 30 16 30C23.7201 30 30 23.7201 30 16C30 8.27995 23.7201 2 16 2ZM16 4.33333C22.4577 4.33333 27.6667 9.54232 27.6667 16C27.6667 22.4577 22.4577 27.6667 16 27.6667C9.54232 27.6667 4.33333 22.4577 4.33333 16C4.33333 9.54232 9.54232 4.33333 16 4.33333ZM11.3333 10.1667V21.8333H13.6667V10.1667H11.3333ZM18.3333 10.1667V21.8333H20.6667V10.1667H18.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseCircleSolid);
export default __webpack_public_path__ + "static/media/pause-circle-solid.d6e9d746b7a367724781ce6d043fba19.svg";
export { ForwardRef as ReactComponent };